import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTCustomMetaTags from './BOTCustomMetaTags'

export default compose(
  withType({ type: 'BOTCustomMetaTags', placeholders: ['content']})
)(BOTCustomMetaTags)
